import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GrossIncomeTaxProfileResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            cm01_form: {name: null, url: null},
            cm05_form: {name: null, url: null},
        };
    }

    cm01Form() {
        return this._adaptFile(this.content()['cm01_form']);
    }

    cm05Form() {
        return this._adaptFile(this.content()['cm05_form']);
    }

    hasMultipleJurisdictions() {
        return this.content()['has_multiple_jurisdictions'] ?? false;
    }

    _adaptFile(file) {
        if (!file || !file.name) {
            return {name: null, url: null};
        }
        return {name: file.name, url: file.url};
    }
}
